import { useCallback, useRef, useEffect } from "react";

/*
const useEventCallback = <Args extends unknown[], R>(
  fn: (...args: Args) => R,
) 
*/

const useEventCallback = (fn) => {
  const ref = useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });

  useEffect(() => {
    ref.current = fn;
  }, [fn]);

  return useCallback((...args) => ref.current(...args), [ref]);
};
export default useEventCallback;
